import React, { useState, useEffect } from 'react';
import { listPalettes } from 'store/auth';
import { useAuth } from 'components/authentication/signup-login/AuthContext';

const ColorPalette = ({ onSelectPalette }) => {
  const { isAuthenticated } = useAuth();

  // Static palettes (existing ones - always available)
  const staticPalettes = [
    {
      name: 'Bluebrown',
      colors: ['#5470C6', '#91CC75', '#EE6666', '#f7be47', '#62b3d6', '#8c6d31', '#6e4a1f'],
    },
    {
      name: 'Bluegreen',
      colors: ['#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b'],
    }
  ];

  const [selectedPalette, setSelectedPalette] = useState('Bluebrown');
  const [dynamicPalettes, setDynamicPalettes] = useState([]);
  const [allPalettes, setAllPalettes] = useState(staticPalettes);

  // Load dynamic palettes from API only if authenticated
  useEffect(() => {
    if (isAuthenticated) {
      loadDynamicPalettes();
    } else {
      // If not authenticated, only use static palettes
      setAllPalettes(staticPalettes);
    }
  }, [isAuthenticated]);

  const loadDynamicPalettes = async () => {
    try {
      const response = await listPalettes();
      const palettes = response.data.palettes || [];
      
      // Transform dynamic palettes for chart usage
      // Chart colors = first 7 contrast colors
      const transformed = palettes.map(palette => {
        const paletteData = palette.palette_data;
        const contrastColors = paletteData.contrast_colors || [];
        
        // Get first 7 contrast colors (index 0-6)
        const first7Contrast = contrastColors.slice(0, 7);
        
        return {
          name: paletteData.palette_name,
          colors: first7Contrast
        };
      });
      
      setDynamicPalettes(transformed);
      // Combine static + dynamic palettes
      setAllPalettes([...staticPalettes, ...transformed]);
    } catch (error) {
      console.error('Error loading palettes:', error);
      // If error, just use static palettes
      setAllPalettes(staticPalettes);
    }
  };

  useEffect(() => {
    const defaultPalette = allPalettes.find((p) => p.name === "Bluebrown");
    if (defaultPalette && onSelectPalette) {
      onSelectPalette(defaultPalette.colors);
    }
  }, [allPalettes, onSelectPalette]);

  const handlePaletteSelect = (palette) => {
    setSelectedPalette(palette.name);
    if (onSelectPalette) {
      onSelectPalette(palette.colors);
    }
  };

  return (
    <div className="mb-3">
      <h5 className="mb-3">Colour</h5>
      <div className="d-flex flex-column" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {allPalettes.map((palette) => (
          <div
            key={palette.name}
            className={`px-2 py-2 rounded d-flex align-items-center justify-content-start ${selectedPalette === palette.name ? 'bg-light' : ''
              }`}
            role="button"
            onClick={() => handlePaletteSelect(palette)}
          >
            {/* Color swatches */}
            <div className="d-flex">
              {palette.colors.map((color, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: color,
                    width: '10px',
                    height: '12px',
                  }}
                ></div>
              ))}
            </div>
            {/* Palette name */}
            <span className="ms-3">{palette.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorPalette;